import {
    BOOT_CAPTCHA_SERVICE,
    GET_GOOGLE_RECAPTCHA_TOKEN,
    GET_SIMPLE_CAPTCHA,
    REFRESH_CAPTCHA,
    REGISTER_GOOGLE_RECAPTCHA,
    REMOVE_GOOGLE_RECAPTCHA_TOKEN,
    SET_CAPTCHA_SERVICE,
    SET_GOOGLE_RECAPTCHA_TOKEN,
    SET_SIMPLE_CAPTCHA
} from "@/core/store/modules/captcha/constants";
import api from "@/core/services/api/api.service";

export default {
    [REGISTER_GOOGLE_RECAPTCHA](context) {
        if (!document.getElementById('recaptcha')) {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${context.state.site_key}`)
            recaptchaScript.id = 'recaptcha'
            document.head.appendChild(recaptchaScript)
        }
    },

    [BOOT_CAPTCHA_SERVICE](context, action) {
        return new Promise((resolve, reject) => {
            api.get(`${process.env.VUE_APP_API_COMMON_URL}/captcha`, {
                params: {
                    action: action
                }
            })
                .then((response) => {
                    context.commit(SET_CAPTCHA_SERVICE, response.data)
                    if (response.data.is_active) {
                        context.dispatch(REFRESH_CAPTCHA)
                    }

                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    [REFRESH_CAPTCHA](context) {

        if (context.state.type === 'recaptcha') {
            context.dispatch(REGISTER_GOOGLE_RECAPTCHA)
            context.dispatch(GET_GOOGLE_RECAPTCHA_TOKEN)
        }

        if (context.state.type === 'simple') {
            context.dispatch(GET_SIMPLE_CAPTCHA)
        }

        if (context.state.type === 'hcaptcha') {
            window.eventBus.$emit('reset-hcaptcha')
        }

        if (context.state.limit === 1) {
            context.dispatch(BOOT_CAPTCHA_SERVICE, context.state.action)
        }
        if (context.state.limit > 0) {
            context.state.limit--
        }

    },

    [GET_SIMPLE_CAPTCHA](context) {
        api.get(context.state.api)
            .then(response => {
                context.commit(SET_SIMPLE_CAPTCHA, response.data)
            }).catch(error => {
        })
    },

    [GET_GOOGLE_RECAPTCHA_TOKEN](context) {
        {
            context.commit(REMOVE_GOOGLE_RECAPTCHA_TOKEN)
            return new Promise((resolve, reject) => {
                try {
                    grecaptcha.ready(function () {
                        grecaptcha.execute(context.state.site_key, {action: context.state.action})
                            .then(function (token) {
                                context.commit(SET_GOOGLE_RECAPTCHA_TOKEN, token)
                                resolve(token)
                            })
                    });
                } catch (ext) {
                    setTimeout(() => {
                        this.dispatch(GET_GOOGLE_RECAPTCHA_TOKEN)
                    }, 2000)
                }


            })

        }
    },
}